import React from 'react'
import { Section, Text } from '../../../../components'
import classNames from 'classnames'

import { getApprovalStepMeta } from '../../utils'

const ApprovalStep = ({ name, status }) => {
  const { label, color, className } = getApprovalStepMeta(status)

  return (
    <Section
      className={classNames(
        className,
        'approval-step-requester cursor-pointer'
      )}
    >
      <Text
        tootipValue={name}
        useTootipFor="name"
        useTootip={true}
        useEllipsis={true}
        style={{ color }}
      >
        {name}
      </Text>
      <p>{label}</p>
    </Section>
  )
}

export default ApprovalStep
